<ng-template [ngIf]="widgetRows && widgetRows.length > 0">
  <button (click)="toggleWidgetSize()" class="textGreen expand-btn font17 absolute cursorPointer"
    [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-light-blue'">
    <fa-icon [icon]="faArrowsLeftRight"></fa-icon>
  </button>
  <ng-template [ngIf]="widgetsLoaded">
    <div *ngFor="let widgetRow of widgetRows; let i = index" class="row gx-2" [ngClass]="{ 'gy-2': i > 0 }">
      <div *ngFor="let item of widgetRow" [ngClass]="item.width">
        <div class="widget animated b-radius full-width"
          [ngClass]="[ item.width, 'widget--' + item.widget.type, getBackgroundClass(item) ]"
          [ngStyle]="{'background-color' : (!item.widget.type.includes('Chart') || item.widget.type != 'RAG' || item.widget.type != 'Progress Bar') ? item.widget.backGroundColor : '#ffffff', 
          'height': item.height,
          'border': (item.widget.type.includes('Chart') || item.widget.type == 'RAG' || item.widget.type == 'Progress Bar') ? '1px solid var(--green)' : 'unset'}"
          style="min-height: 0; min-width: 0; overflow: hidden;">
          <div class="widget__content">
            <ng-template [ngIf]="!item.widget.type.includes('Chart')">
              <ng-template [ngIf]="item.widget.type != 'RAG' && item.widget.type != 'Progress Bar'">
                <span class="widget__caption textWhite">
                  {{ item.widget.caption }}
                </span>
                <span class="widget__value" [style.--primary-color]="item.widget.primaryColor || 'var(--green)'">
                  {{ item.widget.value }}
                </span>
                <ng-template [ngIf]="item.widget.type == 'Trend' && item.widget.trend">
                  <span class="widget__icon">
                    <fa-icon [icon]="item.widget.trend == '+' ? faArrowTrendUp : faArrowTrendDown"></fa-icon>
                  </span>
                </ng-template>
                <ng-template [ngIf]="item.widget.subText && item.width != 'col-4'">
                  <span class="widget__subtext" [style.--secondary-color]="item.widget.secondaryColor || 'white'">
                    {{ item.widget.subText }}
                  </span>
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="item.widget.type == 'RAG'">
                <span class="widget__caption" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                  {{ item.widget.caption }}
                </span>
                <div class="absolute" style="font-size: 40px; top: 50%; transform: translateY(-50%);"
                  *ngIf="item.widget.value == 'AMBER'">🟡</div>
                <div class="absolute" style="font-size: 40px; top: 50%; transform: translateY(-50%);"
                  *ngIf="item.widget.value == 'RED'">🔴</div>
                <div class="absolute" style="font-size: 40px; top: 50%; transform: translateY(-50%);"
                  *ngIf="item.widget.value == 'GREEN'">🟢</div>
              </ng-template>
              <ng-template [ngIf]="item.widget.type == 'Progress Bar'">
                <span class="widget__caption" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                  {{ item.widget.caption }}
                </span>
                <div class="flex" style="transform: translateY(25px);">
                  <span class="textBlack text-centre font15" style="padding: 0px 5px">{{item.widget.value.MinValue}}</span>
                  <div class="" style="height: 20px; width: 100%; max-width: 100%; background-color: aliceblue; border-radius: 50px;">
                    <div class=" flex" [ngStyle]="{'width': calculatePercentage(item.widget.value.MinValue, item.widget.value.MaxValue, item.widget.value.RandomValue)}"
                      style="height: 20px; max-width: 90%; background-color: var(--blue); border-radius: 50px; justify-content: center; align-items: center;">
                        <span class="textWhite text-centre font15">{{item.widget.value.RandomValue}}</span>
                    </div>
                  </div>  
                  <span class="textBlack text-centre font15" style="padding: 0px 5px;">{{item.widget.value.MaxValue}}</span>                              
                </div>
              </ng-template>
            </ng-template>
            <ng-template [ngIf]="item.widget.type.includes('Chart')">
              <chart [settings]="settings" [widget]="item.widget" [maximised]="false" style="width: 100%;"></chart>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
<ng-template [ngIf]="widgetRows && widgetRows.length == 0">
  <div class="padding5 text-centre full-width">
    <span class="font15 padding5 b-radius"
      [ngClass]="[settings.darkModeSetting ? 'textWhite bg-dark-secondary' : 'textBlack bg-light-blue']">
      No widgets for this view
    </span>
  </div>
</ng-template>